/** Reusable surface/card sx helpers — mode-aware via portal tokens or MUI theme. */

export const getPortalCardSx = (portal, extra = {}) => ({
  borderRadius: '16px',
  bgcolor: portal.surface,
  boxShadow: portal.cardShadow,
  border: `1px solid ${portal.border}`,
  ...extra,
});

export const getAuthPageShellSx = () => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: 2,
  py: { xs: 4, sm: 6 },
  position: 'relative',
  overflow: 'hidden',
  bgcolor: 'background.default',
  backgroundImage: (theme) => {
    const accent = theme.palette.primary.main;
    return `
      radial-gradient(ellipse 80% 50% at 50% -20%, ${accent}18 0%, transparent 55%),
      radial-gradient(ellipse 60% 40% at 100% 100%, ${accent}0F 0%, transparent 50%),
      radial-gradient(ellipse 50% 30% at 0% 80%, ${accent}0A 0%, transparent 45%)
    `;
  },
});

export const getAuthPageCardSx = (theme, { maxWidth = 420 } = {}) => ({
  width: '100%',
  maxWidth,
  p: { xs: 3.25, sm: 4.5 },
  borderRadius: '20px',
  bgcolor: 'background.paper',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow:
    theme.portal?.cardShadow ??
    '0 1px 2px rgba(26, 22, 20, 0.04), 0 12px 40px rgba(26, 22, 20, 0.08)',
  position: 'relative',
  zIndex: 1,
});

/** Dashboard widget outer shell — use on grid cells wrapping chart/metric widgets. */
export const portalDashboardCardSx = {
  bgcolor: 'background.paper',
  borderRadius: 2,
  height: '100%',
};

/** Inner metric tile (onboarding, retention, monetisation rows). */
export const portalMetricTileSx = {
  px: 1.5,
  py: 1.35,
  borderRadius: 2,
  bgcolor: 'action.hover',
  color: 'text.primary',
};

/** Progress / funnel bar track behind colored fill. */
export const portalProgressTrackSx = {
  width: '100%',
  height: '100%',
  bgcolor: 'action.hover',
  borderRadius: 1,
};
